import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import Loader from "../../shared/Loader/Loader";
import SubSkillCard from "../../shared/SubSkillCard/SubSkillCard";
import CompletionCard from "../../shared/CompletionCard/CompletionCard";
import Toaster from "../../shared/Toaster/Toaster";
import "./ProgressPage.scss";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { CircularProgress } from "@material-ui/core";
import {
  SkillsListInterface,
  ReachOverallInterface,
  ReachReportSkillList,
  ReachReportSubSkillList,
  LicenseObjectInterface,
  TestResultsDataInterface,
} from "../../../interfaces";
import Accordion from "@material-ui/core/Accordion/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TestResultCard from "../../shared/TestResultCard/TestResultCard";
import ReactGA from "react-ga";
import allActions from "../../../redux/actions";
import { useSelector, useDispatch } from "react-redux";
import ChartsComponent from "../../shared/ChartsComponent/ChartsComponent";
import { useParams } from "react-router-dom";
import { soloProducts, progressPageIds, productList, sprintBusinessProducts } from "../../../globalConstants";
import { getLearnerProgress } from "../../../redux/actions/learnerProgressDetailsAction";
import { getLearnerNewProgressDetailsAction } from "../../../redux/actions/getLearnerNewProgressDetailsAction";
import ProgressCertificate from "../../shared/CompletionCard/progressCertificate";
import ProgressBadge from "../../shared/CompletionCard/progressBadge";
import NoDataFound from "../../shared/NoDataFoundComponent/NoDataFound";
import { getProductName, getProductType, getRandomNumber } from "../../shared/utils/sharedUtils";
import { PRODUCT_TYPES } from "../../shared/utils/sharedConstants";
import ProgressCard from "./ProgressCard";
import ProgressAccordion from "./ProgressAccordionSummary";
import ProgressBar from "./ProgressBar";
import { afterGetLearnerProgressDetails, remapJSON, separateIndivUnitCountBasedOnLevel } from "./customProgressData";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.0)",
  },
  tab: {
    "& .MuiBox-root": {
      padding: "0px",
    },
  },
}));

function TabPanel(props: any) {
  const { children, value, index, prodId, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${prodId}-${index}`}
      // aria-labelledby={`scrollable-auto-tab-${prodId}-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
  prodId: PropTypes.any.isRequired,
};

function a11yProps_dynamic(index: number, prodId: any) {
  return {
    id: `scrollable-auto-tab-${prodId}-${index}`
  };
}

const SprintPage: React.FC = () => {
  let [loaderFlag, setLoaderFlag] = useState(false);
  let [sololoaderFlag, setSoloLoaderFlag] = useState(false);
  const { paramProdID } = useParams();
  const intl = useIntl();
  const allInfo = useSelector((state: any) => state);
  const [pageInited, setPageInited] = useState(false);
  const dispatch = useDispatch();
  const [portalLoginURL, setPortalLoginURL] = useState("");
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [, setL1Expanded] = React.useState<string | false>(false);
  const [, setL2Expanded] = React.useState<string | false>(false);
  const [productTabIndex, setProductTabIndex] = useState(0);
  const [skillTabIndex, setskillTabIndex] = useState(0);
  const [soloTab, setSoloTab] = useState(0);
  const [isSoloStructuredData, setSoloStructuredData] = useState(true);
  const [skillsProgressList, setskillsProgressList] = useState<Array<SkillsListInterface> | undefined>(undefined);
  const [allCompletedList, setAllCompletedList] = useState([]);
  const [isInvalidURL, setIsInvalidURL] = useState(false);
  const [, setAllUnitsIndivList] = useState([]);
  const [, setAllUnitsIndivListSolo] = useState([]);
  const [, setStructuredLevelProgress] = useState([]);
  const [, setStructuredSoloData] = useState([]);
  const [structuredNewSoloData, setStructuredNewSoloData] = useState([]);
  const [activeCourse, setActiveCourse] = useState<any[]>([]);
  const [testResultsList, setTestResultsList] = useState<Array<TestResultsDataInterface> | undefined>([]);
  const [reachReportsCompletedList, setreachReportsCompletedList] = useState<ReachOverallInterface | undefined>(undefined);
  const [reachReportsSkillList, setreachReportsSkillList] = useState<Array<ReachReportSkillList> | undefined>(undefined);
  const [reachReportSubSkillsList, setreachReportSubSkillsList] = useState<Array<ReachReportSubSkillList> | undefined>(undefined);
  const [productsList, setProductsList] = useState<Array<LicenseObjectInterface> | undefined>(undefined);
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });
  const [levelList, setlevelList] = useState<any[]>([]);
  const [levelLoaderFlag, setLevelLoaderFlag] = useState(true);

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  };

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", !!open);
  };

  useEffect(() => {
    if (!!!allInfo.tmsCourses.isLoading && !!!allInfo.tmsCourses.isFailed && !!!allInfo.tmsCourses.data) {
      const uuId = allInfo.common.luuId;
      dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
    }
  }, []);

  useEffect(() => {
    if (!!!allInfo.peopleInformation.isLoading && !!allInfo.peopleInformation.data) {
      const licenseList = allInfo.peopleInformation.data.getpeopleInformation.license;
      if(licenseList) {
        allInfo.peopleInformation.data.getpeopleInformation.license.filter((prod: any) => {
          const licenseName =  getProductType(prod);
          if (licenseName === PRODUCT_TYPES.SOLO) {
            dispatch(allActions.currentSoloCourseAction.getStoreSoloActiveCourseInfo(allInfo.common.leuId, prod.licenseId, prod.productId));
          } else if (licenseName === PRODUCT_TYPES.SPRINT) {
            const uuId = allInfo.common.luuId;
            if (allInfo.tmsCourses.data?.getTMSGetCourse) {
              let activeCourse = allInfo.tmsCourses.data.getTMSGetCourse.filter(
                (courseFilter: any) => courseFilter.status === "3" || courseFilter.status === "1"
              );
              let courseId = 0;
              if (activeCourse.length > 0) {
                courseId = activeCourse[0].courseId;
              } else {
                let latestCompleted = allInfo.tmsCourses.data.getTMSGetCourse.filter(
                  (courseFilter: any) => courseFilter.status === "5"
                );
                courseId =
                  latestCompleted.length > 0
                    ? latestCompleted.sort((a: any, b: any) => b.courseId - a.courseId)[0].courseId
                    : 0;
              }
              dispatch(
                allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(
                  allInfo.common.leuId,
                  prod.licenseId,
                  prod.productId,
                  uuId,
                  courseId
                )
              ); 
            }
          }
        }); 
      }
    }
  }, [allInfo.peopleInformation, allInfo.tmsCourses]);

  const getCurrentLevelTab = (currentCourseLevel: string) => {
    levelList.filter((course, index) => {
      if(course?.title === currentCourseLevel) {
        setSoloTab(index)
        handlesSoloChange(null, index);
      };
      }
    );
  }

  useEffect(() => {
    if (!levelList.length && allInfo?.common?.productID) {
      let productName: string = getProductName(Number(allInfo.common.productID));
      let productType: string = getProductType(Number(allInfo.common.productID));
      if(productName && (productType === PRODUCT_TYPES.SOLO || productType === PRODUCT_TYPES.SPRINT)) {
        if(productName === "sprint_business_english" && !!sessionStorage.getItem("isDemoUser")){
          let dummyData = require("../../../data/MockData/sprintBusinessEnglishDemoLevel.json");
          setlevelList(dummyData);
        } else {
          fetch(`${process.env.REACT_APP_BLOB_STORAGE}/content/${process.env.REACT_APP_OSCAR_ENV}/product_type/${productName}/default.json`)
          .then(response => response.json())
          .then(data => {
            const levelData = data?.level;
            if (levelData) setlevelList(levelData);
          })
        }
      }
    } 
    let currentCourseLevel = allInfo?.currentSoloCourseDetails?.data?.Level ? allInfo?.currentSoloCourseDetails?.data?.Level :
    allInfo?.currentCourseDetails?.data?.Level;
    let currentCourseStatus = allInfo?.currentSoloCourseDetails?.data?.CourseStatus ? allInfo?.currentSoloCourseDetails?.data?.CourseStatus :
    allInfo?.currentCourseDetails?.data?.CourseStatus;
    if(levelList.length && currentCourseLevel && levelLoaderFlag){
      getCurrentLevelTab(currentCourseLevel);
      setLevelLoaderFlag(false);
    } else if(!currentCourseLevel && currentCourseStatus && levelList.length) {
      getCurrentLevelTab(levelList[0].title);
      setLevelLoaderFlag(false);
    }
  }, [levelList, allInfo.common, allInfo.currentSoloCourseDetails, allInfo.currentCourseDetails]);



  useEffect(() => {
    if (!!window.location.href.split("/")[4] && allInfo.common.productID !== window.location.href.split("/")[4]) {
      dispatch(allActions.commonActions.setProductID(window.location.href.split("/")[4]));
    }
  }, [window.location.href, allInfo.common.productID]);
 
  const handleProductChange = (event: any, newValue: any) => {
    const currentTabPid = event.currentTarget.getAttribute("data-product");
    const isProductTab = allInfo.peopleInformation.data.getpeopleInformation.license.some((product: any) => product.productId === currentTabPid);    
    setProductTabIndex(newValue);
    const pushURL: string = `${window.location.protocol}//${window.location.host}/progress`;
    let productID: string = "";
    if (productsList && !!!productsList[newValue].productId.includes("$")) {
      productID = productsList[newValue].productId;
      if(productID) {
        window.history.pushState(null, "", `${pushURL}/${productID}`)
        productID = '';
      } else {
        window.history.pushState(null, "", `${pushURL}`)
      }
    } else {
      window.history.pushState(null, "", `${pushURL}`);
    }
    const currentCourseLevel = allInfo?.currentSoloCourseDetails?.data?.Level;
    if(levelList.length && currentCourseLevel && isProductTab && levelLoaderFlag){
      getCurrentLevelTab(currentCourseLevel);
      setLevelLoaderFlag(false);
    }
  };
  
  const shiftInitialTab = () => {
    if (parseInt(paramProdID as string) ? parseInt(paramProdID as string) : "") {
      switchTab();
    } else {
      setIsInvalidURL(true);
    }
  };

  const switchTab = () => {
    let productIndex = 0, prodIDFound = false;
    if (productsList && productsList.length > 0) {
      productsList.map((prod: any) => {
        if (prod.active) {
          let paramsProductID: any = window.location.pathname.split("/").pop();
          if (parseInt(paramsProductID as string) === parseInt(prod.productId)) {
            setProductTabIndex(productIndex);
            prodIDFound = true;
          }
          productIndex += 1;
        }
      });
      if (!prodIDFound) {
        setIsInvalidURL(true);
      }
    }
  };

  const handleSkillChange = (event: any, newValue: any) => {
    setskillTabIndex(newValue);
  };
  
  const handlesSoloChange = (event: any, newValue: number) => {
    const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
    const level = levelList[newValue];  
    setSoloTab(newValue);
    setSoloLoaderFlag(true);
    dispatch(getLearnerNewProgressDetailsAction(userId.toString(), level.title.toString(), Number(allInfo.common.productID), " "));
  };

  let filledPartList: any = [];
  const calculateAllTotalPerSkill = (allSkillsList: any) => {
    let allSkillsTotal: any = [];
    allSkillsList.forEach((units: any, index: number) => {
      let perSkillTotalPrint = {
        id: index,
        name: units.skilltitle,
        prework: 0,
        homework: 0,
        sessions: 0,
        totalprework: 0,
        totalhomework: 0,
        totalsessions: 0,
        userTestScore: 0,
        maxTestScore : 0,
        level: units.skilllevel,
        skillType : "",
      };

      let consolidatedListObj = units.skillcourses[units.skillcourses.length - 1];
      perSkillTotalPrint["prework"] += parseInt(consolidatedListObj.preworkcompleted);
      perSkillTotalPrint["totalprework"] += parseInt(consolidatedListObj.totalprework);
      perSkillTotalPrint["homework"] += parseInt(consolidatedListObj.homeworkcompleted);
      perSkillTotalPrint["totalhomework"] += parseInt(consolidatedListObj.totalhomework);
      perSkillTotalPrint["sessions"] += parseInt(consolidatedListObj.sessioncompleted);
      perSkillTotalPrint["totalsessions"] += parseInt(consolidatedListObj.totalsession);
      if(consolidatedListObj.skilltypeid === "digital_test") {
        perSkillTotalPrint["skillType"] = consolidatedListObj.skilltypeid;
        perSkillTotalPrint["userTestScore"] += parseInt(consolidatedListObj.usertestscore);
        perSkillTotalPrint["maxTestScore"] += parseInt(consolidatedListObj.maxtestscore);
      }
      allSkillsTotal.push(perSkillTotalPrint);
    });
    return allSkillsTotal;
  };

  const renderReachSubSkill = (reachReportSubSkillsList: Array<object>, skillID: string) => {
    let subskillFilteredList: any = [];
    if (reachReportSubSkillsList && reachReportSubSkillsList.length > 0) {
      reachReportSubSkillsList.forEach((subskill: any, index: number) => {
        if (subskill.SkillId === skillID) {
          subskillFilteredList.push(            
            <div key={index} className="mission-container">
              <div className="mission-title">{subskill.BadgeName}</div>
              <div className="mission-bar">
                <ProgressBar progressPercentage = {parseInt(subskill["TotalMission"]) !== 0 ? (parseInt(subskill["MissionPassed"]) / parseInt(subskill["TotalMission"])) * 100 : 0 }></ProgressBar>
              </div>
              <div className="mission-metric">
                {subskill["MissionPassed"]}/{subskill["TotalMission"]}
              </div>
            </div>
          );
        }
      });
    }
    return subskillFilteredList;
  };

  const afterGetSkillsProgress = () => {
    if (!!!allInfo.skillsProgress.isLoading) {
      if (!!!allInfo.skillsProgress.isFailed) {
        if (!!allInfo.skillsProgress.data) {
          // handle error page here - false
          setskillsProgressList(allInfo.skillsProgress.data.getSkillsReport || []);
          let allCompletedListBefore: any = calculateAllTotalPerSkill(allInfo.skillsProgress.data.getSkillsReport || []);
          setAllCompletedList(allCompletedListBefore);
        } else {
          // handle error page here - true
        }
      } else {
        // handle error page here - true
      }
    }
  };

  const getSkillsProgress = async () => {
    // License check for sprint business skills
    if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
      let licensesList: any =
        allInfo.peopleInformation &&
        allInfo.peopleInformation.data &&
        allInfo.peopleInformation.data.getpeopleInformation ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj })) : [];
      const licenseIDList = getOnlyIds(licensesList) || [];
      if (licenseIDList.indexOf("18") >= 0) {
        if (!!!allInfo.skillsProgress.data && !!!allInfo.skillsProgress.isLoading) {
          await dispatch(allActions.skillsProgressAction.getSkillsProgress(allInfo.common.leuId));
        }
      }
      getReachProgress();
    }
  };

  const afterGetReachProgress = () => {
    if (!!!allInfo.reachProgress.isLoading) {
      if (!!!allInfo.reachProgress.isFailed && !!allInfo.reachProgress.data) {
        const reachReportsData = JSON.parse(allInfo.reachProgress.data.getReachReport);
        setreachReportsCompletedList(reachReportsData.data[0]);
        setreachReportsSkillList(reachReportsData.data[1]);
        setreachReportSubSkillsList(reachReportsData.data[2]);
        // handle error page here - false
      } else {
        // handle error page here - true
      }
    }
  };

  const getReachProgress = async () => {
    // License check for Reach API
    let licensesList: any =
      allInfo.peopleInformation && allInfo.peopleInformation.data && allInfo.peopleInformation.data.getpeopleInformation
        ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
        : [];
    const licenseIDList = getOnlyIds(licensesList) || [];
    if (licenseIDList.indexOf("15") >= 0) {
      const { accountId, token }: any = allInfo.peopleInformation.data.getpeopleInformation;
      if (!!!allInfo.reachProgress.data && !!!allInfo.reachProgress.isLoading) {
        await dispatch(allActions.reachProgressAction.getReachProgress(allInfo.common.leuId, accountId, token));
      }
    }
  };

  const sugarCoatNamesAndFilter = (rawLics: Array<LicenseObjectInterface>) => {
    let finalRawLicenses: any = [],
      rawLicenseArr: Array<LicenseObjectInterface> = rawLics;
    const mandatoryTabs: any = [
      {
        productId: "$0",
        productName: intl.formatMessage({ "id" : "progress_activity_report" }),
        active: 1,
      },
      {
        productId: "$1",
        productName: intl.formatMessage({ "id" : "progress_test_results" }),      
        active: 1,
      }
    ];

    let sugarCoatedPrefixes = progressPageIds.map((id: string) => {
      let productObj = productList.find((product: any) => product.productId === id);
      return {
        productId: id,
        productName: productObj ? productObj.productName : "",
      };
    });
    rawLicenseArr = [...mandatoryTabs, ...rawLicenseArr];
    sugarCoatedPrefixes = [...sugarCoatedPrefixes, ...mandatoryTabs];

    // Remove licenses based on active state
    for (let k = 0; k < rawLicenseArr.length; k++) {
      if (parseInt(rawLicenseArr[k]["active"]) === 0) {
        rawLicenseArr.splice(k, 1);
      }
    }

    for (let i = 0; i < rawLicenseArr.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (rawLicenseArr[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
          finalRawLicenses.push(rawLicenseArr[i]);
        }
      }
    }

    // sugarcoat names in licenses
    for (let i = 0; i < finalRawLicenses.length; i++) {
      for (let j = 0; j < sugarCoatedPrefixes.length; j++) {
        if (parseInt(finalRawLicenses[i]["active"]) === 1) {
          if (finalRawLicenses[i]["productId"] === sugarCoatedPrefixes[j]["productId"]) {
            finalRawLicenses[i]["productName"] = sugarCoatedPrefixes[j]["productName"];
          }
        } else {
          finalRawLicenses.splice(i, 1);
        }
      }
    }

    return finalRawLicenses;
  };

  const getOnlyIds = (licenseArr: any) => {
    let lArr: any = [];
    if (licenseArr && licenseArr.length > 0) {
      licenseArr.map((prod: any) => {
        lArr.push(prod.productId);
      });
    }
    return lArr;
  };

  const afterGetTestResultsAPI = () => {
    if (!!!allInfo.testProgress.isLoading) {
      if (!!!allInfo.testProgress.isFailed) {
        if (!!allInfo.testProgress.data) {
          if(!!!allInfo.testProgress.data["learnerTestResults"]){
            setTestResultsList(allInfo.testProgress.data);
          } else {
            setTestResultsList(allInfo.testProgress.data["learnerTestResults"])
          }
          // handle error page here - false
        }
      } else {
        // handle error page here - true
      }
      getSkillsProgress();
    }
  };

  const getTestResultsAPI = async () => {
    //  && (process.env.REACT_APP_ENVIRONMENT !== "test" || sessionStorage.getItem("isDemoUser"))
    if (!!!allInfo.testProgress.data && !!!allInfo.testProgress.isLoading) {
      dispatch(allActions.testProgressAction.getTestProgress(allInfo.common.leuId, allInfo.peopleInformation.data.getpeopleInformation.accountId, Number(allInfo.common.productID)));      
    }
  };

  const initGoogleAnalytics = () => {
    if (allInfo.peopleInformation.data.getpeopleInformation.serviceConfiguration.features.substring(84, 85) === "1") {
      const trackingId: string = process.env.REACT_APP_GA_TRACKING_ID || "";
      ReactGA.initialize(trackingId);
      const url = window.location.pathname;
      ReactGA.set({ page: url });
      ReactGA.pageview(url);
    }
  };

  const afterGetPeopleInfo = () => {
    if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
      let licensesList: any =
        allInfo.peopleInformation &&
        allInfo.peopleInformation.data &&
        allInfo.peopleInformation.data.getpeopleInformation
          ? allInfo.peopleInformation.data.getpeopleInformation.license.map((obj: any) => ({ ...obj }))
          : [];
      // handle error page here - false
      initGoogleAnalytics();
      setProductsList(sugarCoatNamesAndFilter(licensesList));
      generatePortalURL();
    } else {
      // handle error page here - true
    }
  };

  const getPeopleInfo = () => {
    afterGetPeopleInfo();
  };

  const handleAccordionChange = (panel: string, level?: number) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    if (level === 1) {
      setL1Expanded(isExpanded ? panel : false);
    } else if (level === 2) {
      setL2Expanded(isExpanded ? panel : false);
    } else {
      setExpanded(isExpanded ? panel : false);
    }
  };

  const filterSpecificProductCourses = (data: any, ID: number, isSolo = false) => {
    return {
      skilllevel: data.skilllevel,
      skilltitle: data.skilltitle,
      userid: data.userid,
      username: data.username,
      skillcourses: !!!isSolo ? data.skillcourses.filter((course: any) => course.skilltypeid === ID) : data.skillcourses,
    };
  };

  const restructureSprintLevelProgressData = (data: any, isSolo = false) => {
    let structuredArr: any = [],
      levelsList: any = [];

    if (data && data.data && data.data.userskillscourseslist && data.data.userskillscourseslist.length > 0) {
      data.data.userskillscourseslist.map((datum: any) => {
        if (levelsList.indexOf(datum.skilllevel) === -1) {
          let singleDataObj: any = {
            level: datum.skilllevel,
            courses: [],
          };
          singleDataObj.courses.push(filterSpecificProductCourses(datum, 2, isSolo));
          structuredArr.push(singleDataObj);
          levelsList.push(datum.skilllevel);
        } else {
          for (let i = 0; i < structuredArr.length; i++) {
            if (structuredArr[i].level === datum.skilllevel) {
              structuredArr[i].courses.push(filterSpecificProductCourses(datum, 2, isSolo));
            }
          }
        }
      });
    }

    if (structuredArr && structuredArr.length > 0) {
      let sortedCourses: any = structuredArr[0].courses.sort((a: any, b: any) =>
        a.skillcourses[0].courseparttitle.toLowerCase().localeCompare(b.skillcourses[0].courseparttitle.toLowerCase())
      );
      structuredArr[0]["courses"] = sortedCourses;
      for (let i = 0; i < structuredArr.length; i++) {
        structuredArr[i].parts = {
          parts: generatePartSprint(structuredArr[i], isSolo),
        };
      }
      return structuredArr;
    } else return [];
  };

  const calculateOverallUnitsCompletion = (seperatedUnitsList: Array<any>) => {
    for (let i = 0; i < seperatedUnitsList.length; i++) {
      for (let j = 0; j < seperatedUnitsList[i].units.length; j++) {
        seperatedUnitsList[i].prework += seperatedUnitsList[i].units[j].prework;
        seperatedUnitsList[i].totalprework += seperatedUnitsList[i].units[j].totalprework;
        seperatedUnitsList[i].sessions += seperatedUnitsList[i].units[j].sessions;
        seperatedUnitsList[i].totalsessions += seperatedUnitsList[i].units[j].totalsessions;
      }
    }
    return seperatedUnitsList;
  };

  const generatePortalURL = () => {
    if (!!!allInfo.portalLogin.isFailed && !!allInfo.portalLogin.data) {
      let { key, signature } = JSON.parse(allInfo.portalLogin.data.getPortalLoginKey);
      let url =
        process.env["REACT_APP_PROFILE_URL"] +
        "/account/portallogin?key=" +
        key +
        "&signature=" +
        signature +
        "&virtual_step=1";
      // handle error page here - false
      setPortalLoginURL(url);
      getTestResultsAPI();
    } else {
      // handle error page here - true
    }
  };

  const afterSprintLevelProgressAPI = (reStructuredWithTotal: any) => {
    for (let i = 0; i < reStructuredWithTotal.length; i++) {
      reStructuredWithTotal[i].parts.parts.map((singleFilledPart: any) => {
        let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(singleFilledPart.courses)
        singleFilledPart.total = calculateOverallUnitsCompletion(separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []);
      });
    }
    const simplifiedJSON: any = [];
    let remappedJSON: any = {};
    remappedJSON["skilltitle"] = {};
    allInfo.learnerProgressDetails.data.map((eachObject: any) => {
      simplifiedJSON.push(remapJSON(remappedJSON, eachObject, {}, true));
    });
    let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(simplifiedJSON);
    setAllUnitsIndivList(
      mergeUnits(calculateOverallUnitsCompletion(separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []))
    );
    setStructuredLevelProgress(reStructuredWithTotal);
  };

  const afterLearnerProgressAPI = () => {
    let userskillscourseslist: any = {};
    userskillscourseslist.data = {};
    userskillscourseslist.data.userskillscourseslist = [];
    if (!!!allInfo.learnerProgressDetails.isLoading) {
      if (!!!allInfo.learnerProgressDetails.isFailed && !!allInfo.learnerProgressDetails.data) {
        let reStructuredWithTotal: any;
        let remappedJSON: any = {};
        remappedJSON["skilltitle"] = {};
        allInfo.learnerProgressDetails.data.map((progressDetails: any) => {
          userskillscourseslist = remapJSON(remappedJSON, progressDetails, userskillscourseslist, false)
        });
        reStructuredWithTotal = restructureSprintLevelProgressData(userskillscourseslist, true)
        if (allInfo.common.productID === "20") {
          afterSprintLevelProgressAPI(reStructuredWithTotal);
        } else {
          if (
            allInfo.learnerProgressDetails &&
            allInfo.learnerProgressDetails.data &&
            allInfo.learnerProgressDetails.data &&
            typeof allInfo.learnerProgressDetails.data === "object" &&
            allInfo.learnerProgressDetails.data.length > 0
          ) {
            for (let i = 0; i < reStructuredWithTotal.length; i++) {
              reStructuredWithTotal[i].parts.parts.map((singleFilledPart: any) => {
                let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(singleFilledPart.courses);
                singleFilledPart.total = calculateOverallUnitsCompletion(
                  separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || []
                );
              });
            }

            let allCompletedListUnitbefore: any = calculateAllTotalPerSkill(
              userskillscourseslist.data.userskillscourseslist
            );
            setAllUnitsIndivListSolo(mergeUnits(calculateOverallUnitsCompletion(separateIndivUnitCountBasedOnLevel(allCompletedListUnitbefore) || [])));
            setSoloStructuredData(false);
            setStructuredSoloData(reStructuredWithTotal);
          } else {
            setSoloStructuredData(false);
            setAllUnitsIndivListSolo([]);
          }
        }
      }
      if (allInfo.learnerProgressDetails.data.length === 0) setSoloStructuredData(false);
    }
  };

  const getLearnerProgressAPI = async () => {
    if (!!allInfo.peopleInformation.data) {
      const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
      dispatch(getLearnerProgress(userId.toString(), Number(allInfo.common.productID)));
    }
  };

  const generatePartSprint = (structuredUnParted: any, isSolo = false) => {
    let partsList = [];
    let partsStringList = [];
    for (let j = 0; j < structuredUnParted.courses.length; j++) {
      for (let k = 0; k < structuredUnParted.courses[j].skillcourses.length; k++) {
        if (partsStringList.indexOf(structuredUnParted.courses[j].skillcourses[0].courseparttitle) === -1) {
          partsStringList.push(structuredUnParted.courses[j].skillcourses[0].courseparttitle);
          let partsObj = {
            level: structuredUnParted.courses[j].skilllevel,
            courseparttitle: structuredUnParted.courses[j].skillcourses[0].courseparttitle,
            courses: [],
            total: [],
          };
          partsList.push(partsObj);
        }
      }
    }
    return fillPartsArray(partsList, structuredUnParted);
  };

  const fillPartsArray = (partsList: any, structuredUnParted: any) => {
    let notedDownTitles: any = [];
    for (let j = 0; j < structuredUnParted.courses.length; j++) {
      for (let k = 0; k < structuredUnParted.courses[j].skillcourses.length; k++) {
        partsList.map((part: any) => {
          if (part.courseparttitle === structuredUnParted.courses[j].skillcourses[0].courseparttitle) {
            if (notedDownTitles.indexOf(structuredUnParted.courses[j].skilltitle) === -1) {
              notedDownTitles.push(structuredUnParted.courses[j].skilltitle);
              part.courses.push(structuredUnParted.courses[j]);
            }
          }
        });
      }
    }
    return (filledPartList = partsList);
  };

  const mergeUnits = (unmergedList: any) => {
    let allUnitsList: any = [];
    for (let i = 0; i < unmergedList.length; i++) {
      allUnitsList.push(...unmergedList[i].units);
    }
    return allUnitsList;
  };

  useEffect(() => {
    if (productsList && productsList.length > 0) {
      shiftInitialTab();
    }
  }, [productsList]);

  useEffect(() => {
    setPageInited(true);
    sessionStorage.removeItem("chInited");  
  }, []);

  useEffect(() => {
    if (!!!allInfo.common.isLoading && !!!allInfo.peopleInformation.isLoading && !!!allInfo.portalLogin.isLoading) {
      if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data) {
        getPeopleInfo();
      }
    }
  }, [allInfo.common, allInfo.peopleInformation, allInfo.portalLogin]);

  useEffect(() => {
    if (!!!allInfo.skillsProgress.isLoading) {
      if (allInfo.common.productID !== "29") {
        afterGetSkillsProgress();
      }
    }
  }, [allInfo.skillsProgress, allInfo.common.productID]);

  useEffect(() => {
    if (!!!allInfo.testProgress.isLoading) {
      afterGetTestResultsAPI();
    }
  }, [allInfo.testProgress]);

  useEffect(() => {
    if (!!!allInfo.reachProgress.isLoading) {
      afterGetReachProgress();
    }
  }, [allInfo.reachProgress]);
  
  // Common effect for all products
  useEffect(() => {
    if (!!!allInfo.learnerProgressDetails.isLoading && !!!allInfo.learnerProgressDetails.isFailed && ((soloProducts.includes(allInfo.common.productID) || sprintBusinessProducts.includes(allInfo.common.productID)))) {
    (!!allInfo.learnerProgressDetails.data) ? afterLearnerProgressAPI() : getLearnerProgressAPI();
    }
  }, [allInfo.peopleInformation, allInfo.common.productID]);

  useEffect(() => {
    if (!allInfo.getLearnerProgressDetails.isLoading && !allInfo.getLearnerProgressDetails.isFailed && allInfo.getLearnerProgressDetails.data &&
      ((soloProducts.includes(allInfo.common.productID) || sprintBusinessProducts.includes(allInfo.common.productID)))) {            
      setSoloLoaderFlag(false);
      const reFormatedData = afterGetLearnerProgressDetails(allInfo.getLearnerProgressDetails.data.modules, allInfo.common.productID);
      setStructuredNewSoloData(reFormatedData);
    } else if (!allInfo.getLearnerProgressDetails.isLoading && allInfo.getLearnerProgressDetails.isFailed) {
      setSoloLoaderFlag(false);
      setStructuredNewSoloData(allInfo.getLearnerProgressDetails.data);
    }
  }, [allInfo.getLearnerProgressDetails]);

  useEffect(() => {
    if (
      !!!allInfo.peopleInformation.isLoading &&
      !!!allInfo.portalLogin.isLoading &&
      !!!allInfo.skillsProgress.isLoading &&
      !!!allInfo.testProgress.isLoading &&
      !!!allInfo.reachProgress.isLoading &&
      (process.env.REACT_APP_ENVIRONMENT === "test" ||
        !soloProducts.includes(allInfo.common.productID) ||
        (soloProducts.includes(allInfo.common.productID) && !isSoloStructuredData))
    ) {
      setLoaderFlag(false);
      if (isInvalidURL) {
        setTimeout(() => {
          window.history.pushState(null, "", `${window.location.protocol}//${window.location.host}/progress`);
        }, 1000);
      }
    } else {
      setLoaderFlag(true);
    }
  }, [
    allInfo.peopleInformation,
    allInfo.portalLogin,
    allInfo.skillsProgress,
    allInfo.testProgress,
    allInfo.reachProgress,
    allInfo.sprintLevelProgress,
    isSoloStructuredData,
  ]);

  useEffect(() => {
    if (!!!allInfo.peopleInformation.isFailed && !!allInfo.peopleInformation.data && !!allInfo.common.productID) {
      const userId = allInfo.peopleInformation.data.getpeopleInformation.edgeUid;
      if (
        !!!allInfo.skillOutcomeSummary.isLoading &&
        !!!allInfo.skillOutcomeSummary.isFailed &&
        !!!allInfo.skillOutcomeSummary.data && 
        allInfo.common.productID !== "25"
      ) {
        dispatch(allActions.skillOutcomeSummaryAction.getSkillOutcome(userId.toString(), Number(allInfo.common.productID)));
      }
    }
  }, [allInfo.peopleInformation, allInfo.common.productID, allInfo.skillOutcomeSummary]);


  

  useEffect(() => {
    if (!!!allInfo.peopleInformation.isLoading && !!allInfo.peopleInformation.data && !sessionStorage.getItem('isDemoUser')) {
      let licences = allInfo.peopleInformation.data.getpeopleInformation.license;
      if (licences.length > 0) {
        dispatch(allActions.commonActions.setProductID(licences[0].productId));
      }
    }

    if (!!!allInfo.peopleInformation.isLoading && !!!allInfo.tmsCourses.isLoading) {
      if (!!allInfo.peopleInformation.data && !!allInfo.tmsCourses.data) {
        const filteredSprintLevelLic = allInfo.peopleInformation.data.getpeopleInformation.license.filter(
          (prod: any) => {
            return (
              prod.productId === "20" ||
              prod.productId === "18" ||
              prod.productId === "21" ||
              prod.productId === "22" ||
              prod.productId === "23" ||
              prod.productId === "24" ||
              prod.productId === "25"
            );
          }
        );
        if (
          !!!allInfo.currentCourseDetails.isLoading &&
          !!!allInfo.currentCourseDetails.isFailed &&
          !!!allInfo.currentCourseDetails.data
        ) {
          const uuId = allInfo.common.luuId;
          let activeCourse = allInfo.tmsCourses.data.getTMSGetCourse.filter(
            (courseFilter: any) => courseFilter.status === "3" || courseFilter.status === "1"
          );
          let courseId = 0;
          if (activeCourse.length > 0) {
            courseId = activeCourse[0].courseId;
          } else {
            let latestCompleted = allInfo.tmsCourses.data.getTMSGetCourse.filter(
              (courseFilter: any) => courseFilter.status === "5"
            );
            courseId =
              latestCompleted.length > 0
                ? latestCompleted.sort((a: any, b: any) => b.courseId - a.courseId)[0].courseId
                : 0;
          }
          setActiveCourse(activeCourse);
          if (filteredSprintLevelLic && filteredSprintLevelLic.length > 0) {
            dispatch(
              allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(
                allInfo.common.leuId,
                filteredSprintLevelLic[0].licenseId,
                filteredSprintLevelLic[0].productId,
                uuId,
                courseId
              )
            );
          }
        }
      }
      if (!!allInfo.currentCourseDetails.isFailed) {
        setLoaderFlag(false);
        dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
      }
    }
  }, [allInfo.peopleInformation, allInfo.currentCourseDetails, allInfo.tmsCourses]);

  return (
    <React.Fragment>
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />      
      <Loader showLoader={loaderFlag} />
      {true ? (
        <div className="progresspage-container">
          <div className="progresspage-title">
            <h1>{translate("progress_title")}</h1>
          </div>
          <div className="progresspage-body">
            <div className={classes.root}>
              <AppBar position="static" color="default">
                <Tabs
                  value={productTabIndex}
                  className={"tabs-trigger-container h1-tab"}
                  onChange={handleProductChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="Product list tabs"
                >
                  {productsList &&
                    productsList.map((product: any, mainIndex: number) => {
                      return (
                        <Tab
                          key={product.productId}
                          data-product={product.productId}
                          label={product.productName}
                          {...a11yProps_dynamic(mainIndex, "auto")}
                        />
                      );
                    })}
                </Tabs>
              </AppBar>
              {productsList &&
                productsList.map((product: any, listIndex: number) => {
                  if (product.productId === "18") {
                    return (
                      <TabPanel key={listIndex} value={productTabIndex} index={listIndex} prodId={"auto"}>
                        {skillsProgressList && skillsProgressList.length > 0 ? (
                          <div className="inside-tab">
                            <AppBar position="static" color="default">
                              <Tabs
                                value={skillTabIndex}
                                className={"tabs-trigger-container h2-tab"}
                                onChange={handleSkillChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                aria-label="Skill list tabs"
                              >
                                {skillsProgressList &&
                                  skillsProgressList.map((skill: any, index: number) => {
                                    return (
                                      <Tab
                                        key={index * Math.random()}
                                        label={skill["skilltitle"]}
                                        {...a11yProps_dynamic(index, "18")}
                                      />
                                    );
                                  })}
                              </Tabs>
                            </AppBar>
                            {skillsProgressList &&
                              skillsProgressList.map((skill: any, index: number) => {
                                return (
                                  <TabPanel
                                    key={index * Math.random()}
                                    value={skillTabIndex}
                                    index={index}
                                    prodId={"18"}
                                  >
                                    <div className="skill-note">{translate("progress_skill_note")}</div>
                                    <div className="completion-card-cover">
                                      <CompletionCard
                                        type="0"
                                        title={translate("progress_overall_card_title_prework")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="1"
                                        title={translate("progress_overall_card_title_homework")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="2"
                                        title={translate("progress_overall_card_title_session")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="8"
                                        title={translate("progress_overall_card_title_badge")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                      <CompletionCard
                                        type="3"
                                        title={translate("progress_overall_card_title_certificate")}
                                        cardData={allCompletedList[index] || {}}
                                      />
                                    </div>
                                    <div className="subskill-list">
                                      {skillsProgressList[index].skillcourses &&
                                      skillsProgressList[index].skillcourses.length > 0 ? (
                                        skillsProgressList[index].skillcourses.map((subskillData: any, index: number) => {
                                          return (
                                            <SubSkillCard
                                              key={index}
                                              subSkillData={subskillData}
                                              showHomeWork={true}
                                              skillSummary={allInfo.skillOutcomeSummary.data}
                                            ></SubSkillCard>
                                          );
                                        })
                                      ) : (
                                        <div className="emptySubSkill">{translate("progress_noSubskill")}</div>
                                      )}
                                    </div>
                                  </TabPanel>
                                );
                              })}
                          </div>
                        ) : (
                          <NoDataFound />
                        )}
                      </TabPanel>
                    );
                  } else if (product.productId === "15") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        {reachReportsCompletedList && reachReportsSkillList && reachReportSubSkillsList ? (
                          <div className="tab-main-body m0 p0">
                            <div className="completion-card-cover">
                              <CompletionCard
                                type="4"
                                title={translate("progress_overall_card_title_skillsCompleted")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="5"
                                title={translate("progress_overall_card_title_badgesEarned")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="6"
                                title={translate("progress_overall_card_title_missionsPassed")}
                                cardData={reachReportsCompletedList || {}}
                              />
                              <CompletionCard
                                type="7"
                                title={translate("progress_overall_card_title_timeInReach")}
                                cardData={reachReportsCompletedList || {}}
                              />
                            </div>
                            <div className="reach-skills-body-container">
                              <ul className="reach-skills-card-ul">
                                {reachReportsSkillList &&
                                  reachReportsSkillList.map((skill: any, index: number) => {
                                    return (
                                      <Accordion
                                        key={index}
                                        className={
                                          skill["UserCurrentGoal"] === 0
                                            ? "reach-skill-card"
                                            : "reach-skill-card user-selected"
                                        }
                                        expanded={expanded === `${skill["SkillId"]}`}
                                        onChange={handleAccordionChange(`${skill["SkillId"]}`)}
                                      >
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls={skill.SkillId}
                                          id="panel1a-header"
                                        >
                                          <div className="reach-skill-title">
                                            {" "}
                                            {skill["SkillName"]}{" "}
                                            {parseInt(skill["UserCurrentGoal"]) === 1 &&
                                            parseInt(skill["IsAchieved"]) === 0 ? (
                                              <div className="inprogress-chip">{translate("progress_inprogress")}</div>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </AccordionSummary>
                                        <AccordionDetails className="accordion-details">
                                          <li className="reach-skills-card-li">
                                            <div className="reach-skill-subskill-list">
                                              <div className="missions-list-cover">
                                                {reachReportSubSkillsList && (
                                                  <div>
                                                    {renderReachSubSkill(reachReportSubSkillsList, skill["SkillId"])}
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </li>
                                        </AccordionDetails>
                                      </Accordion>
                                    );
                                  })}
                              </ul>
                            </div>
                          </div>
                        ) : (
                          <NoDataFound />
                        )}
                      </TabPanel>
                    );
                  } else if (product.productId === "20" || product.productId === "26" || product.productId === "27" || product.productId === "28") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        {levelList && levelList.length > 0 ? (
                          <div className="tab-main-body m0 p0 inside-tab">
                            <div className="reach-skills-body-container">
                              <div className="levels-progress-skills-card-ul">
                                <div>
                                  <AppBar position="static" color="transparent">
                                    <Tabs
                                    value={soloTab}
                                    onChange={handlesSoloChange}
                                    className={"tabs-trigger-container h2-tab"}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="sprint levels level tabs"
                                    >                                      
                                      {levelList && 
                                      levelList.map((level: any, index: number)=>{
                                       return(
                                            <Tab
                                              label={level.title}
                                              key={index * Math.random()}
                                              {...a11yProps_dynamic(index, "21")}
                                            />
                                       );
                                      })
                                      }
                                    </Tabs>
                                  </AppBar>                                                                    
                                 {sololoaderFlag ? 
                                 <div className="circular-progress-container">
                                  <div className="circular-progress-img">
                                     <CircularProgress size={50} color="primary"/>
                                     </div>
                                 </div>
                                  :
                                  structuredNewSoloData && 
                                    structuredNewSoloData.map((skill: any, index: number) => {                                  
                                        return (
                                        <div key={getRandomNumber(index)} className="part-container">
                                          <div className="part-title">{translate("progress_partText")} {skill.courseTitle}</div>
                                          <div className="part-details-wrap">
                                            <ProgressCard 
                                              percentagePartCompleted={skill.percentagePartCompletedExercise} 
                                              percentagePartLabel="progress_overall_card_title_prework">
                                            </ProgressCard>
                                            <ProgressCard 
                                              percentagePartCompleted={skill.perPartSessionDetail}
                                              sessionCard={ true } 
                                              percentagePartLabel="progress_overall_card_title_session">
                                            </ProgressCard>
                                            <ProgressBadge skill={skill}>
                                            </ProgressBadge>
                                            <ProgressCertificate skill={skill}>
                                            </ProgressCertificate>
                                          </div>
                                          {skill && skill.courseDetailObj.map((individualModule: any, index: number) => {
                                            return (
                                            <div key={getRandomNumber(index)} className="module-wrap">
                                              <ProgressAccordion key={index} sessionModule={true} courseModule = { individualModule }></ProgressAccordion>
                                            </div>
                                            );
                                          })}
                                        </div>
                                        );
                                    })
                                  }                                 
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <NoDataFound />
                        )}
                      </TabPanel>
                    );
                  } else if (product.productId === "$0") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>  
                        <div className="test-results-all-cards-cover white">
                          <ChartsComponent pageInited={pageInited} />
                        </div>
                      </TabPanel>
                    );
                  } else if (product.productId === "$1") {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <div className="test-results-all-cards-cover">
                          {testResultsList && testResultsList.length > 0 ? (
                            testResultsList.map((result, index: number) => {
                              return <TestResultCard key={index} portalLoginURL={portalLoginURL} result={result} productId={allInfo.common.productID}></TestResultCard>;
                            })
                          ) : (
                            <NoDataFound />
                          )}
                        </div>
                      </TabPanel>
                    );
                  } else {
                    return (
                      <TabPanel value={productTabIndex} index={listIndex} key={Math.random()} prodId={"auto"}>
                        <NoDataFound />
                      </TabPanel>
                    );
                  }
                })}
            </div>
          </div>
        </div>
      ) : (
        <ErrorPage status={404} />
      )}
    </React.Fragment>
  );
};

SprintPage.propTypes = { productsList: PropTypes.array };

export default SprintPage